import Cart from 'software_products/components/Cart';
import renderSubscriptionProduct from 'software_products/renderSubscriptionProduct';

renderSubscriptionProduct(Cart);
